import { CSSProperties, FC, SyntheticEvent } from 'react';

import styled from 'styled-components';

const StyledImage = styled.img<{ sliderImage?: boolean }>`
  width: 100%;
  /* antd carousel has an issues with 100% so I had to set a static value */

  display: block;
  object-fit: cover;
  min-height: 313px;
  height: 100%;

  ${({ sliderImage }) =>
    sliderImage &&
    `
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px;
  `}

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    min-height: 200px;
    height: 200px;

    ${({ sliderImage }) =>
      sliderImage &&
      `
    border-radius: 8px;
  `}
  }
`;

interface Props {
  imageSrc?: string;
  alt?: string;
  sliderImage?: boolean;
  fallBackImage?: string;
  imageStyle?: CSSProperties;
  onImageClick?(): void;
}

const ItemImage: FC<Props> = ({
  imageSrc,
  fallBackImage = '/static/images/placeholder-image.webp',
  alt,
  sliderImage = false,
  imageStyle,
  onImageClick,
}) => {
  const addImageFallback = (event: SyntheticEvent<HTMLImageElement, Event>) => {
    event.currentTarget.src = fallBackImage;
  };

  return (
    <StyledImage
      sliderImage={sliderImage}
      src={imageSrc}
      alt={alt}
      style={imageStyle}
      onError={addImageFallback}
      onClick={onImageClick}
    />
  );
};

export default ItemImage;
